/**
 * T078: New Prompt Route
 * Route for creating a new prompt
 */

import { createFileRoute } from '@tanstack/react-router'
import { PromptNewPage } from '@/pages/prompts/prompt-new'

export const Route = createFileRoute('/_authenticated/prompts/new')({
  component: PromptNewPage,
})
